import { gql } from 'graphql-tag'

/**
 * Clone a case for a sibling — everything about the family is copied, only the
 * child differs.
 *
 * `input` is JSON, matching the other case writes (`importCase`), and resolves to
 * `{ id, title, siblingsLinked, copied[] }` — `copied` names what actually
 * came across so the toast can say it instead of guessing.
 */
export const CLONE_CASE_MUTATION = gql`
  mutation CloneCase($input: JSON!) {
    cloneCase(input: $input)
  }
`
